"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationOpportunityDto = instanceOfOrientationOpportunityDto;
exports.OrientationOpportunityDtoFromJSON = OrientationOpportunityDtoFromJSON;
exports.OrientationOpportunityDtoFromJSONTyped = OrientationOpportunityDtoFromJSONTyped;
exports.OrientationOpportunityDtoToJSON = OrientationOpportunityDtoToJSON;
exports.OrientationOpportunityDtoToJSONTyped = OrientationOpportunityDtoToJSONTyped;
const SpecialtyAbbrDto_1 = require("./SpecialtyAbbrDto");
const StipendDto_1 = require("./StipendDto");
const ProfileNameDto_1 = require("./ProfileNameDto");
const OrientationOpportunitySessionDto_1 = require("./OrientationOpportunitySessionDto");
const OrientationOpportunityStatus_1 = require("./OrientationOpportunityStatus");
const FacilityDto_1 = require("./FacilityDto");
const OrientationRequesterSummaryDto_1 = require("./OrientationRequesterSummaryDto");
const OrientationNurseSummaryDto_1 = require("./OrientationNurseSummaryDto");
const LicenseType_1 = require("./LicenseType");
/**
 * Check if a given object implements the OrientationOpportunityDto interface.
 */
function instanceOfOrientationOpportunityDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('licenseType' in value) || value['licenseType'] === undefined)
        return false;
    if (!('payRate' in value) || value['payRate'] === undefined)
        return false;
    if (!('totalRate' in value) || value['totalRate'] === undefined)
        return false;
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('orientationSessions' in value) || value['orientationSessions'] === undefined)
        return false;
    if (!('facility' in value) || value['facility'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('specialtyCode' in value) || value['specialtyCode'] === undefined)
        return false;
    if (!('lastEditedAt' in value) || value['lastEditedAt'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('pointOfContactName' in value) || value['pointOfContactName'] === undefined)
        return false;
    if (!('postedByProfile' in value) || value['postedByProfile'] === undefined)
        return false;
    if (!('lastEditedByProfile' in value) || value['lastEditedByProfile'] === undefined)
        return false;
    if (!('requests' in value) || value['requests'] === undefined)
        return false;
    if (!('matchesCount' in value) || value['matchesCount'] === undefined)
        return false;
    return true;
}
function OrientationOpportunityDtoFromJSON(json) {
    return OrientationOpportunityDtoFromJSONTyped(json, false);
}
function OrientationOpportunityDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'licenseType': (0, LicenseType_1.LicenseTypeFromJSON)(json['licenseType']),
        'description': json['description'] == null ? undefined : json['description'],
        'payRate': json['payRate'],
        'totalRate': json['totalRate'],
        'startTime': (new Date(json['startTime'])),
        'orientationSessions': (json['orientationSessions'].map(OrientationOpportunitySessionDto_1.OrientationOpportunitySessionDtoFromJSON)),
        'facility': (0, FacilityDto_1.FacilityDtoFromJSON)(json['facility']),
        'status': (0, OrientationOpportunityStatus_1.OrientationOpportunityStatusFromJSON)(json['status']),
        'specialtyCode': json['specialtyCode'],
        'specialty': json['specialty'] == null ? undefined : (0, SpecialtyAbbrDto_1.SpecialtyAbbrDtoFromJSON)(json['specialty']),
        'lastEditedAt': (new Date(json['lastEditedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'stipends': json['stipends'] == null ? undefined : (json['stipends'].map(StipendDto_1.StipendDtoFromJSON)),
        'stipendMinimumDistance': json['stipendMinimumDistance'] == null ? undefined : json['stipendMinimumDistance'],
        'pointOfContactName': json['pointOfContactName'],
        'pointOfContactPhone': json['pointOfContactPhone'] == null ? undefined : json['pointOfContactPhone'],
        'pointOfContactEmail': json['pointOfContactEmail'] == null ? undefined : json['pointOfContactEmail'],
        'postedByProfile': (0, ProfileNameDto_1.ProfileNameDtoFromJSON)(json['postedByProfile']),
        'lastEditedByProfile': (0, ProfileNameDto_1.ProfileNameDtoFromJSON)(json['lastEditedByProfile']),
        'requests': json['requests'],
        'matchesCount': json['matchesCount'],
        'hasNewRequests': json['hasNewRequests'] == null ? undefined : json['hasNewRequests'],
        'requesterNurses': json['requesterNurses'] == null ? undefined : (json['requesterNurses'].map(OrientationRequesterSummaryDto_1.OrientationRequesterSummaryDtoFromJSON)),
        'requesterCount': json['requesterCount'] == null ? undefined : json['requesterCount'],
        'matchedNurses': json['matchedNurses'] == null ? undefined : (json['matchedNurses'].map(OrientationNurseSummaryDto_1.OrientationNurseSummaryDtoFromJSON)),
        'matchedCount': json['matchedCount'] == null ? undefined : json['matchedCount'],
    };
}
function OrientationOpportunityDtoToJSON(json) {
    return OrientationOpportunityDtoToJSONTyped(json, false);
}
function OrientationOpportunityDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'licenseType': (0, LicenseType_1.LicenseTypeToJSON)(value['licenseType']),
        'description': value['description'],
        'payRate': value['payRate'],
        'totalRate': value['totalRate'],
        'startTime': ((value['startTime']).toISOString()),
        'orientationSessions': (value['orientationSessions'].map(OrientationOpportunitySessionDto_1.OrientationOpportunitySessionDtoToJSON)),
        'facility': (0, FacilityDto_1.FacilityDtoToJSON)(value['facility']),
        'status': (0, OrientationOpportunityStatus_1.OrientationOpportunityStatusToJSON)(value['status']),
        'specialtyCode': value['specialtyCode'],
        'specialty': (0, SpecialtyAbbrDto_1.SpecialtyAbbrDtoToJSON)(value['specialty']),
        'lastEditedAt': ((value['lastEditedAt']).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'stipends': value['stipends'] == null ? undefined : (value['stipends'].map(StipendDto_1.StipendDtoToJSON)),
        'stipendMinimumDistance': value['stipendMinimumDistance'],
        'pointOfContactName': value['pointOfContactName'],
        'pointOfContactPhone': value['pointOfContactPhone'],
        'pointOfContactEmail': value['pointOfContactEmail'],
        'postedByProfile': (0, ProfileNameDto_1.ProfileNameDtoToJSON)(value['postedByProfile']),
        'lastEditedByProfile': (0, ProfileNameDto_1.ProfileNameDtoToJSON)(value['lastEditedByProfile']),
        'requests': value['requests'],
        'matchesCount': value['matchesCount'],
        'hasNewRequests': value['hasNewRequests'],
        'requesterNurses': value['requesterNurses'] == null ? undefined : (value['requesterNurses'].map(OrientationRequesterSummaryDto_1.OrientationRequesterSummaryDtoToJSON)),
        'requesterCount': value['requesterCount'],
        'matchedNurses': value['matchedNurses'] == null ? undefined : (value['matchedNurses'].map(OrientationNurseSummaryDto_1.OrientationNurseSummaryDtoToJSON)),
        'matchedCount': value['matchedCount'],
    };
}
//# sourceMappingURL=OrientationOpportunityDto.js.map